/**
 * GMAT Focus Edition mock exam metadata + official GMAC resources.
 * Official exams are linked out (mba.com) — we do not re-host GMAC content.
 */

export type ExamAuthenticity = "official" | "sigma";

export interface OfficialExamResource {
  id: string;
  name: string;
  description: string;
  url: string;
  price: string;
  questions: string;
}

export interface ExamSectionBlueprint {
  id: string;
  label: string;
  minutes: number;
  question_count: number;
}

export interface ExamBlueprintSummary {
  id: string;
  title: string;
  subtitle: string;
  authenticity: ExamAuthenticity;
  total_minutes: number;
  total_questions: number;
  sections: ExamSectionBlueprint[];
}

/** GMAT Focus Edition section timing (for reference UI). */
export const GMAT_FOCUS_STRUCTURE = {
  totalMinutes: 135,
  optionalBreakMinutes: 10,
  sections: [
    { id: "quant", label: "Quantitative Reasoning", questions: 21, minutes: 45 },
    { id: "verbal", label: "Verbal Reasoning", questions: 23, minutes: 45 },
    { id: "di", label: "Data Insights", questions: 20, minutes: 45 },
  ],
} as const;
